import React , {useState } from "react";
import BookingRefund from "src/components/_services/insurance/Tigo/BookingRefund.js";

const TestPage = () => {
  const response = {
    "ResponseStatus": {
        "status": 1,
        "msg": "Price Not Changed"
    },
    "IsPriceChange": false,
    "BookingFlightDetails": [
        {
            "sessionId": "",
            "data": "",
            "tripType": 1,
            "cid": "",
            "gdsType": 96,
            "key": "",
            "adultNumber": 1,
            "childNumber": 0,
            "infantNumber": 0,
            "currency": "INR",
            "fare": {
                "FareType": "",
                "Fare_Id": "",
                "adultFare": 3461,
                "childFare": 0,
                "infantFare": 0,
                "infantWsFare": 0,
                "adultTax": 795,
                "childTax": 0,
                "infantTax": 0,
                "infantWsTax": 0,
                "adultMarkup": 0,
                "childMarkup": 0,
                "infantMarkup": 0,
                "infantWsMarkup": 0,
                "bagFees": 0,
                "grandTotal": 4506,
                "markupID": 0,
                "markupType": "US",
                "totalMarkup": 0,
                "grandOrgTotal": 4256,
                "baseFare": 3461,
                "totalTax": 795,
                "YQTax": 0,
                "OtherCharges": 1,
                "offeredFare": 4256,
                "FareBreakdown": [],
                "AdditionalTxnFeeOfrd": 0,
                "AdditionalTxnFeePub": 0,
                "discount": 0,
                "PublishedFare": null,
                "TdsOnPLB": 0,
                "TdsOnIncentive": 0,
                "ServiceFee": 0,
                "gstPrice": 0,
                "convinenceFeeMeta": 0,
                "convenienceFees": 250,
                "convinenceFeeStatusMeta": "yes"
            },
            "additionalInfo": {
                "catlogId": "o1",
                "Adult": 1,
                "Child": 0,
                "Infant": 0,
                "currency": "INR",
                "tripType": 1,
                "offerReference": {
                    "OfferQueryBuildFromProducts": {
                        "BuildFromProductsRequest": {
                            "@type": "BuildFromProductsRequestAir",
                            "PassengerCriteria": [
                                {
                                    "@type": "PassengerCriteria",
                                    "number": 1,
                                    "passengerTypeCode": "ADT"
                                }
                            ],
                            "ProductCriteriaAir": [
                                {
                                    "SpecificFlightCriteria": [
                                        {
                                            "flightNumber": "613",
                                            "carrier": "AI",
                                            "departureDate": "2025-09-24",
                                            "departureTime": "05:30:00",
                                            "arrivalDate": "2025-09-24",
                                            "arrivalTime": "06:50:00",
                                            "from": "BOM",
                                            "to": "AMD",
                                            "classOfService": "T",
                                            "cabin": "Economy",
                                            "segmentSequence": 1,
                                            "AvailabilitySourceCode": "S",
                                            "ContentSource": "GDS"
                                        }
                                    ],
                                    "sequence": 1
                                }
                            ]
                        },
                        "validateInventoryInd": true
                    }
                }
            },
            "MetaLinkId": 700000670171
        }
    ],
    "hit": "reSearch",
    "addons": {
        "ProductCode": "BRONZE",
        "ProductName": "Bronze Service",
        "ProductPrice": 95,
        "BagCoverage": 19000,
        "CurrencyName": "INR",
        "_id": "6878aef99fde4dc72d16282f"
    },
    "insurancePlan": {},
    "refundablePlan": {
        "amount": 450.6,
        "currency": "INR",
        "refundable_terms_url": "https://refundablebooking.com/refundable-terms",
        "refundRequest_url": "https://form.refundablebooking.com/forms/refund"
    },
    "extraBaggage": []
}
  return (
    <div>
      <BookingRefund priceCheckResponse={response} />
    </div>
  )
}

export default TestPage;


function TestPageDemoOne() {
 const [ackoData, setAckoData] = useState(process.env.REACT_APP_ACKO_BASE_URL);
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <header className="bg-white shadow-md sticky top-0 z-50">
        <nav className="container mx-auto flex justify-between items-center py-4 px-6">
          <div className="text-2xl font-bold">{ackoData}</div>
          <ul className="flex space-x-6 text-lg">
            <li><a href="#about" className="hover:text-blue-600">About</a></li>
            <li><a href="#projects" className="hover:text-blue-600">Projects</a></li>
            <li><a href="#contact" className="hover:text-blue-600">Contact</a></li>
          </ul>
        </nav>
      </header>

      <main className="container mx-auto px-6 py-16">
        {/* Hero Section */}
        <section className="text-center mb-24">
          <h1 className="text-5xl font-extrabold mb-4">Hi, I'm YourName</h1>
          <p className="text-xl text-gray-700 mb-8">A passionate Frontend Developer</p>
          <a
            href="#projects"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition"
          >
            View My Work
          </a>
        </section>

        {/* About Section */}
        <section id="about" className="max-w-3xl mx-auto mb-24">
          <h2 className="text-3xl font-semibold mb-6">About Me</h2>
          <p className="text-gray-700 leading-relaxed">
            I am a frontend developer with experience in React, Tailwind CSS, and building responsive web applications. I love turning designs into clean, functional websites.
          </p>
        </section>

        {/* Projects Section */}
        <section id="projects" className="mb-24">
          <h2 className="text-3xl font-semibold mb-12 text-center">Projects</h2>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* Example Project Card */}
            <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition">
              <h3 className="text-xl font-bold mb-2">Project One</h3>
              <p className="text-gray-600 mb-4">A brief description of the project goes here.</p>
              <a href="#" className="text-blue-600 hover:underline">View Details</a>
            </div>
            {/* Add more project cards similarly */}
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-semibold mb-6">Get In Touch</h2>
          <p className="mb-6 text-gray-700">Feel free to reach out for collaborations or just a friendly hello 👋</p>
          <a
            href="mailto:your.email@example.com"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition"
          >
            Email Me
          </a>
        </section>
      </main>

      <footer className="bg-white border-t py-6 text-center text-gray-600">
        &copy; {new Date().getFullYear()} YourName. All rights reserved.
      </footer>
    </div>
  );
  
}